// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"29148642","1144":"29148642","1362":"29148642","2271":"29148642","2341":"29148642"}[chunkId] + ".chunk.css";
};